import { useTranslation } from "react-i18next";
import { MdCheck } from "react-icons/md";
import BarcodeDecor from "./Barcode";

export default function Payments() {
  const { t } = useTranslation();
  const details = [
    { label: t("Landing.decor.payments.service"), value: t("Landing.decor.payments.serviceValue") },
    { label: t("Landing.decor.payments.meter"), value: "•••• 7319" },
    { label: t("Landing.decor.payments.amount"), value: t("Landing.decor.currency", { value: "350.00" }) },
    { label: t("Landing.decor.payments.fees"), value: t("Landing.decor.currency", { value: "0.00" }) },
  ];
  return (
    <div className="flex w-90 flex-col gap-4 rounded-2xl bg-background-default px-6 py-6 font-poppins drop-shadow-lg" aria-hidden={true}>
      <div className="flex flex-col items-center gap-2">
        <div className="flex size-14 items-center justify-center rounded-full bg-background-success text-font-success">
          <MdCheck className="size-7" />
        </div>
        <span className="mt-2 text-xl font-semibold">{t("Landing.decor.payments.title")}</span>
        <span className="text-sm">{t("Landing.decor.payments.date")}</span>
      </div>
      <div className="my-4 border-t border-dashed border-border-default" />
      <div className="flex flex-col gap-2 font-mono text-sm">
        {details.map(({ label, value }) => (
          <div key={label} className="flex items-center justify-between">
            <span>{label}</span>
            <span>{value}</span>
          </div>
        ))}
      </div>
      <div className="my-4 border-t border-dashed border-border-default" />
      <div className="flex items-end justify-between">
        <span className="text-xs font-semibold uppercase tracking-widest">{t("Landing.decor.paidWith")}</span>
        <span className="text-3xl font-bold text-font-active">
          7,000 <span className="text-sm font-medium">{t("Landing.decor.pointsUnit")}</span>
        </span>
      </div>
      <div className="mt-4 flex flex-col items-center gap-1">
        <BarcodeDecor />
        <span className="font-mono text-xs tracking-widest">0549 1983 5577</span>
      </div>
    </div>
  );
}
